import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import TablePageHeading from "../../dashboard_pages/components/page_heading/TablePageHeading";
import CardTabs from "../../dashboard_pages/components/cards/CardTabs";
import { Block } from "../../../components/Component";
import TableList from "../../dashboard_pages/components/table/TableList";
import * as app_consts from "../../../constants/react_app_consts";
import { client_actions_helper } from "../../../actions/actions_helper";
import { useDispatch, useSelector } from "react-redux";
import {
  fail_retrieve_goods_received_list,
  loading_retrieve_goods_received_list,
  reset_retrieve_goods_received_list,
  success_retrieve_goods_received_list,
} from "../../../reducers/client_reducers/goods_received/retrieve_goods_received_list_Slice";
import {
  RETRIEVE_GOODS_RECEIVED_LIST_ACCESS_DENIED_MSG,
  RETRIEVE_GOODS_RECEIVED_LIST_ERR_MSG,
  RETRIEVE_GOODS_RECEIVED_LIST_SUCCESS_MSG,
} from "../../../constants/success_error_messages_consts";
import { RETRIEVE_CLIENTS_GOODS_RECEIVED_LIST_API } from "../../../api/api_data";
import { messageToast } from "../../../utils/Utils";
import { Spinner } from "reactstrap";
import { BiErrorCircle } from "react-icons/bi";

const type = app_consts.CLIENT_GOODS_RECEIVED_LIST;

const GoodsReceivedList = ({ account_type }) => {
  const dispatch = useDispatch();

  const [page_data, setPageData] = useState([]);
  const [activeCardTab, setActiveCardTab] = useState("Fully Processed");
  const [dataFetched, setDataFetched] = useState(false);
  const [fully_processed_data, setFullyProcessedData] = useState([]);
  const [partially_processed_data, setPartiallyProcessedData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const log_cred = useSelector((state) => state.logged_in_cred.logged_in_cred);
  const retrieve_goods_received_list = useSelector(
    (state) => state.retrieve_goods_received_list.retrieve_goods_received_list,
  );

  useEffect(() => {
    retrieve_goods_received_list_func();
  }, []);

  const tabs = [{ tabName: "Fully Processed" }, { tabName: "Pending" }];

  const retrieve_goods_received_list_func = () => {
    setError("");
    dispatch(
      client_actions_helper(
        loading_retrieve_goods_received_list,
        success_retrieve_goods_received_list,
        fail_retrieve_goods_received_list,
        RETRIEVE_GOODS_RECEIVED_LIST_ERR_MSG,
        RETRIEVE_GOODS_RECEIVED_LIST_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_CLIENTS_GOODS_RECEIVED_LIST_API,
        null,
        RETRIEVE_GOODS_RECEIVED_LIST_ACCESS_DENIED_MSG,
      ),
    );
  };

  useEffect(() => {
    if (retrieve_goods_received_list.status !== app_consts.IDLE) {
      if (retrieve_goods_received_list.status === app_consts.LOADING) {
        setError("");
        setLoading(true);
      } else {
        setLoading(false);

        if (retrieve_goods_received_list.status === app_consts.FAIL) {
          setError(retrieve_goods_received_list.message);
          messageToast(retrieve_goods_received_list.message, app_consts.FAIL);
        } else if (retrieve_goods_received_list.status === app_consts.SUCCESS) {
          setPageData(retrieve_goods_received_list?.data?.data || retrieve_goods_received_list?.data || []);
        }

        dispatch(reset_retrieve_goods_received_list());
      }
    }
  }, [retrieve_goods_received_list, dispatch]);

  const refreshList = () => {
    retrieve_goods_received_list_func();
    setPageData([]);
    setFullyProcessedData([]);
    setPartiallyProcessedData([]);
  };

  useEffect(() => {
    if (Array.isArray(page_data)) {
      const complete_data = page_data.filter(
        (item) =>
          item?.weigh_bridge_ticket?.weigh_bridge_ticket_status_id ===
          app_consts.WEIGH_BRIDGE_TICKET_PROCESSING_COMPLETE,
      );

      const uncomplete_data = page_data.filter(
        (item) =>
          item?.weigh_bridge_ticket?.weigh_bridge_ticket_status_id !==
          app_consts.WEIGH_BRIDGE_TICKET_PROCESSING_COMPLETE,
      );

      setFullyProcessedData(complete_data);
      setPartiallyProcessedData(uncomplete_data);
    } else {
      setFullyProcessedData([]);
      setPartiallyProcessedData([]);
    }
  }, [page_data]);

  const getCsvExportData = () => {
    if (activeCardTab === "Fully Processed") return fully_processed_data;
    if (activeCardTab === "Pending") return partially_processed_data;
    return page_data;
  };

  return (
    <>
      <Head title="Goods Received List" />
      <div className="items-center w-80 m-auto">
        <Content>
          <TablePageHeading
            title="Goods Received Tickets List"
            description={`Total Goods Received Tickets: ${Array.isArray(page_data) ? page_data.length : 0}`}
            refresh
            refreshFunc={refreshList}
            csv_export={!loading && !error}
            page_type={type}
            pageData={getCsvExportData()}
            title_addition={log_cred?.data?.username}
            backToText="Home"
            backToLink="/customer"
          />

          <Block>
            {loading ? (
              <div className="p-5 d-flex align-center justify-center">
                <Spinner />
              </div>
            ) : error && error.length > 0 ? (
              <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
                <BiErrorCircle className="text-danger fs-3" />
                <p>{error}</p>
              </div>
            ) : (
              <>
                <CardTabs
                  cardTabs={tabs}
                  activeCardTab={activeCardTab}
                  setActiveCardTab={setActiveCardTab}
                  dataFetched={setDataFetched}
                />

                {activeCardTab === "Fully Processed" && <TableList type={type} data={fully_processed_data} />}

                {activeCardTab === "Pending" && <TableList type={type} data={partially_processed_data} />}
              </>
            )}
          </Block>
        </Content>
      </div>
    </>
  );
};

export default GoodsReceivedList;
